import AssessmentIcon from '@mui/icons-material/Assessment';
import ConstructionIcon from '@mui/icons-material/Construction';
import StraightenIcon from '@mui/icons-material/Straighten';
import TimelineIcon from '@mui/icons-material/Timeline';
import type { ElementType } from 'react';
import type { LayerKey } from '../../../../core/mapV2/indicators';

export const LAYER_ICONS: Record<LayerKey, ElementType> = {
    sessions: TimelineIcon,
    reference: StraightenIcon,
    network: AssessmentIcon,
    projects: ConstructionIcon,
};

// Entries of the "···" menu of each layer. All of them are actions from later phases for now
// (see docs/map-v2/plan.md), so they are listed but disabled. The network layer has no menu
// (its only entry in the maquette, the symbology editor, is admin-only).
export const LAYER_MENU_ITEMS: Record<LayerKey, string[]> = {
    sessions: ['mapV2.layers.menu.addSession', 'mapV2.layers.menu.openSessionsTable'],
    reference: ['mapV2.layers.menu.importReference', 'mapV2.layers.menu.importHistory'],
    network: [],
    projects: ['mapV2.layers.menu.openProjectsTable'],
};
